import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Login from './pages/Login/Login';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from './utils/Layout';
import PrivateRoutes from './utils/PrivateRoutes';
import {Context} from './context/stateContext';
import GroupSelection from './pages/Login/GroupSelection';

function App() {
  return (
    <BrowserRouter>
    <Context>
      <Routes>
        <Route path='' exact element={<Login />} />
        <Route path='/*' element={<PrivateRoutes component={Layout} />} />
        <Route path="/login/group-selection" element={<PrivateRoutes component={GroupSelection} />} />
      </Routes>
    </Context>
      <ToastContainer
          position="top-right"
          autoClose={6608}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="dark"
        />
    </BrowserRouter>
  );
}

export default App;
